package games.polyclub.website.frontend.store.pages.aof7

import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.frontend.lib.react.simplified.tags.*
import games.polyclub.frontend.lib.react.utils.classSet
import react.Props
import react.dom.aria.ariaExpanded
import react.useState
import web.window.WindowTarget

val AOF7HowToInstall = SFC<Props> { _ ->
    val (isInstallTutorialCurseForgeExpanded, setInstallTutorialCurseForgeExpanded) = useState(false)
    val (isInstallTutorialPrismLauncherExpanded, setInstallTutorialPrismLauncherExpanded) = useState(false)

    +"Damos suporte a dois launches diferentes, o CurseForge e o PrismLauncher."
    div {
        div("card card-green mb-1") {
            div("card-header") {
                h4("card-title w-100") {
                    a("d-block w-100 cursor-pointer") {
                        if (!isInstallTutorialPrismLauncherExpanded) {
                            classSet += "collapsed"
                        }
                        href="#"
                        ariaExpanded = isInstallTutorialPrismLauncherExpanded
                        +"Prism Launcher"
                        onClick = { ev ->
                            ev.preventDefault()
                            setInstallTutorialPrismLauncherExpanded(!isInstallTutorialPrismLauncherExpanded)
                        }
                    }
                }
            }
            div("collapse") {
                if (isInstallTutorialPrismLauncherExpanded) {
                    classSet += "show"
                }
                div("card-body") {
                    p {
                        +"Este é um launcher que dá suporte melhorado a mods e modpacks que também permite o download de mods do CurseForge, Modrinth, FTB e outros provedores em um lugar só."
                    }
                    p {
                        +"Para utilizar o Prism Launcher como inicializador do modpack: "
                    }
                    ol {
                        li {
                            +"Baixe e instale a "
                            a {
                                +"última versão do Java JDK 17"
                                target = WindowTarget._blank
                                href = "https://www.oracle.com/java/technologies/downloads/#jdk17-windows"
                            }
                            +"(Link Direto: "
                            a{
                                +"Windows x64"

                                target = WindowTarget._blank
                                href = "https://download.oracle.com/java/17/latest/jdk-17_windows-x64_bin.msi"
                            }
                            +")"
                            br()
                            img("w-50") {
                                src = "/img/tutoriais/prism/0-instalar-java.jpg"
                            }
                        }
                        li {
                            a {
                                href = "https://prismlauncher.org/download/"
                                target = WindowTarget._blank
                                +"Baixe o "
                                strong {
                                    +"Prism Launcher"
                                }
                            }
                            +", você pode escolher entre "
                            strong {+"Portable" }
                            em { +" (não requer instalação, basta extrair o zip do programa em uma pasta vazia)" }
                            +" ou instalar de forma convencional."
                            br()
                            +" O único detalhe é que você pode precisar instalar o "
                            strong {+"Microsoft Visual C++ Redistributable"}
                            +" caso você ainda não tenha instalado direta ou indiretamente, o link para download da dependência está na página de download do Prism Launcher."
                            br()
                            img("w-50") {
                                src = "/img/tutoriais/prism/1-instalar-prism.jpg"
                            }
                        }
                        li("mt-2") {
                            +"Execute o Prism pelo ícone no menu iniciar ou pelo "
                            strong {
                                +"prismlauncher.exe"
                            }
                            +" caso tenha instalado a versão "
                            strong {
                                +"Portable"
                            }
                            br()
                            img("h-25") {
                                src = "/img/tutoriais/prism/2-executar-prism.jpg"
                            }
                        }
                        li("mt-2") {
                            +"Selecione o seu idioma de preferência e clique em "
                            strong {
                                +"Avançar"
                            }
                            br()
                            img("w-50") {
                                src = "/img/tutoriais/prism/3-idioma.png"
                            }
                        }
                        li("mt-2") {
                            +"Selecione o Java de versão "
                            strong {
                                +"17"
                            }
                            +" e mude a "
                            strong {
                                +"Alocação máxima de memória"
                            }
                            +" para algo "
                            strong {
                                +"entre 4096 MiB e 8192 MiB"
                            }
                            +", depois avance, escolha o tema que quiser e clique em "
                            strong {
                                +"Finalizar"
                            }
                            br()
                            img("w-50") {
                                src = "/img/tutoriais/prism/4-selecionar-java.png"
                            }
                        }
                        li("mt-2") {
                            +"Clique em "
                            strong {
                                +"Adicionar Instância"
                            }
                            br()
                            img("w-50") {
                                src = "/img/tutoriais/prism/5-adicionar-instancia.png"
                            }
                        }
                        li("mt-2") {
                            +"Selecione "
                            strong {
                                +"CurseForge"
                            }
                            +" e busque por "
                            strong {
                                +"AOF7"
                            }
                            +", ajuste a versão caso necessário (normalmente estamos na última) e clique em "
                            strong {
                                +"OK"
                            }
                            br()
                            img("w-50") {
                                src = "/img/tutoriais/prism/6-instale-modpack.png"
                            }
                        }
                        li("mt-2") {
                            +"Devido a restrições do CurseForge, alguns mods precisam ser baixados manualmente, felizmente o Prism Launcher "
                            +"criou uma forma bem interessante de fazer isso rapidamente."
                            ol {
                                li {
                                    +"Clique em "
                                    strong {
                                        +"Abrir os que faltam"
                                    }
                                    +", será aberto todos os links de download direto dos mods que faltam no seu navegador de uma vez só"
                                }
                                li {
                                    +"Deixe o navegador baixar tudo na mesma pasta"
                                }
                                li {
                                    +"Volte para a janela e você verá a indicação de que "
                                    strong {
                                        +"Todos os mods foram encontrados"
                                    }
                                    +", caso essa frase não apareça, veja se faltou baixar alguma aba no seu navegador."
                                }
                                li {
                                    +"Clique em "
                                    strong {
                                        +"OK"
                                    }
                                    +" para prosseguir."
                                }
                            }
                            br()
                            img("w-50") {
                                src = "/img/tutoriais/prism/7-mods-bloqueados.png"
                            }
                        }
                        li("mt-2") {
                            p {
                                +"Agora que você já tem o essencial para jogar, recomendamos que instale também o mod "
                                strong {
                                    +"Simple Voice Chat"
                                }
                                +". Ele permite que você converse com os outros jogadores no jogo por voz, ou só os escute caso não queira falar."
                            }
                            p {
                                +"Estes passos são opcionais, este mod não é obrigatório para se conectar."
                            }
                            ol {
                                li("mt-2") {
                                    +"Após instalado, selecione o modpack e clique em "
                                    strong {
                                        +"Editar"
                                    }
                                    br()
                                    img("w-50") {
                                        src = "/img/tutoriais/prism/8-editar.png"
                                    }
                                }
                                li("mt-2") {
                                    +"Clique em "
                                    strong {
                                        +"Mods"
                                    }
                                    +" e em seguida em "
                                    strong {
                                        +"Baixar mods"
                                    }
                                    br()
                                    img("w-50") {
                                        src = "/img/tutoriais/prism/9-baixar-mods.png"
                                    }
                                }
                                li("mt-2") {
                                    +"Selecione "
                                    strong {
                                        +"CurseForge"
                                    }
                                    +" ou "
                                    strong {
                                        +"Modrinth"
                                    }
                                    +" (este mod está disponível nos dois)"
                                    +" em seguida busque por "
                                    strong {
                                        +"voice"
                                    }
                                    +" selecione "
                                    strong {
                                        +"Simple Voice Chat"
                                    }
                                    +", ajuste a versão se necessário (normalmente usamos a última), clique em "
                                    strong {
                                        +"Selecione mod para download"
                                    }
                                    +", e clique em "
                                    strong {
                                        +"Revise e confirme"
                                    }
                                    +". Uma janela irá abrir, clique em "
                                    strong {
                                        +"OK"
                                    }
                                    +" para confirmar."
                                    br()
                                    img("w-50") {
                                        src = "/img/tutoriais/prism/10-simple-voice-chat.png"
                                    }
                                }
                            }
                        }
                    }
                    p("mt-2") {
                        +"Agora você já pode clicar em "
                        strong {
                            +"Launch"
                        }
                        +", se autenticar e jogar. Veja mais detalhes na guia "
                        strong {
                            +"Como Jogar"
                        }
                        br()
                        img("w-25") {
                            src = "/img/aof7/screenshot/tela-inicial.jpg"
                        }
                    }
                }
            }
        }
        div("card card-gray-dark mb-1") {
            div("card-header") {
                h4("card-title w-100") {
                    a("d-block w-100 cursor-pointer") {
                        if (!isInstallTutorialCurseForgeExpanded) {
                            classSet += "collapsed"
                        }
                        href="#"
                        ariaExpanded = isInstallTutorialCurseForgeExpanded
                        +"CurseForge"
                        onClick = { ev ->
                            ev.preventDefault()
                            setInstallTutorialCurseForgeExpanded(!isInstallTutorialCurseForgeExpanded)
                        }
                    }
                }
            }
            div("collapse") {
                if (isInstallTutorialCurseForgeExpanded) {
                    classSet += "show"
                }
                div("card-body") {
                    p {
                        +"Este é um launcher popular que dá suporte melhorado a mods e modpacks que também permite a hospedagem de mods e é muito utilizado por criadores de mods para divulgar seus mods."
                    }
                    p {
                        +"Para utilizar o CurseForge como inicializador do modpack: "
                    }
                    ol {
                        li {
                            a {
                                href = "https://www.curseforge.com/download/app"
                                target = WindowTarget._blank
                                +"Baixe o "
                                strong {
                                    +"instalador do CurseForge"
                                }
                            }
                            +", você pode escolher instalar em "
                            strong {+"Standalone" }
                            em { +" (recomendável por nós)" }
                            +" ou ligado ao Overwolf, um segundo programa."
                            br()
                            img("w-25") {
                                src = "/img/tutoriais/curseforge/1-instalar.jpg"
                            }
                        }
                        li("mt-2") {
                            +"Abra o "
                            strong {
                                +"CurseForge"
                            }
                            +" e selecione "
                            strong {
                                +"Minecraft"
                            }
                            br()
                            img("w-25") {
                                src = "/img/tutoriais/curseforge/2-selecionar-minecraft.jpg"
                            }
                        }
                        li("mt-2") {
                            +"No campo de busca, busque por "
                            strong {
                                +"AOF7"
                            }
                            +" e instale o modpack "
                            strong {
                                +"All Of Fabric 7"
                            }
                            br()
                            img("w-50") {
                                src = "/img/tutoriais/curseforge/3-pesquisar-aof7.jpg"
                            }
                        }
                        li("mt-2") {
                            p {
                                +"Agora que você já tem o essencial para jogar, recomendamos que instale também o mod "
                                strong {
                                    +"Simple Voice Chat"
                                }
                                +". Ele permite que você converse com os outros jogadores no jogo por voz, ou só os escute caso não queira falar."
                            }
                            p {
                                +"Estes passos são opcionais, este mod não é obrigatório para se conectar."
                            }
                            ol {
                                li("mt-2") {
                                    +"Após instalado, clique no "
                                    strong {
                                        +"ícone de opções"
                                    }
                                    +" e abra "
                                    strong {
                                        +"Profile Options"
                                    }
                                    br()
                                    img("w-50") {
                                        src = "/img/tutoriais/curseforge/4-abrir-profile-options.jpg"
                                    }
                                }
                                li("mt-2") {
                                    +"Ative "
                                    strong {
                                        +"Content Management"
                                    }
                                    +" e clique em "
                                    strong {
                                        +"Done"
                                    }
                                    br()
                                    img("w-25") {
                                        src = "/img/tutoriais/curseforge/5-ativar-content-management.jpg"
                                    }
                                }
                                li("mt-2") {
                                    +"Clique no "
                                    strong {
                                        +"ícone de opções"
                                    }
                                    +" novamente e selecione "
                                    strong {
                                        +"Add More Content"
                                    }
                                    br()
                                    img("w-50") {
                                        src = "/img/tutoriais/curseforge/6-add-more-content.jpg"
                                    }
                                }
                                li("mt-2") {
                                    +"Pesquise por "
                                    strong {
                                        +"voice"
                                    }
                                    +" e instale o mod "
                                    strong {
                                        +"Simple Voice Chat"
                                    }
                                    +", depois clique no "
                                    strong {
                                        +"X"
                                    }
                                    +" indicado na imagem para voltar ao modpack."
                                    br()
                                    img("w-50") {
                                        src = "/img/tutoriais/curseforge/7-simple-voice-chat.jpg"
                                    }
                                }
                                li("mt-2") {
                                    +"Após instalado, clique no "
                                    strong {
                                        +"ícone de opções"
                                    }
                                    +" outra vez e abra"
                                    strong {
                                        +"Profile Options"
                                    }
                                    +" novamente."

                                    br()
                                    img("w-50") {
                                        src = "/img/tutoriais/curseforge/8-profile-options-de-novo.jpg"
                                    }
                                }
                                li("mt-2") {
                                    +"Desative a opção "
                                    strong {
                                        +"Content Management"
                                    }
                                    +" de volta e clique em "
                                    strong {
                                        +"Done"
                                    }
                                    br()
                                    img("w-25") {
                                        src = "/img/tutoriais/curseforge/9-desativar-content-management.jpg"
                                    }
                                }
                            }
                        }
                    }
                    p("mt-2") {
                        +"Agora você já pode clicar em "
                        strong {
                            +"Play"
                        }
                        +", se autenticar e jogar. Veja mais detalhes na guia "
                        strong {
                            +"Como Jogar"
                        }
                        br()
                        img("w-25") {
                            src = "/img/aof7/screenshot/tela-inicial.jpg"
                        }
                    }
                }
            }
        }
    }
}
